// *** TECH  DECORATORS (EXTERNAL TECH) ***
import TechDecorator from "./decorators/TechDecorator";
import YouTubeDecorator from "./decorators/YouTubeDecorator";
import SkyClickPlayer from "../components/custom/SkyClickPlayer";

// *** OWN TECH ***
// currently no custom - later we import here our custom torrent tech

/**
 * For each player instance we have a TechManager instance to manage tech bootup process
 * The static functions call the static tech stuff, that we run only once per pageload
 */
export default class TechManager{

    static techDecoratorClasses:any[] = [
        YouTubeDecorator
    ];

    static customTechClasses:any[] = [

    ];

    /**
     * Get tech decorator and custom class references
     * @returns {any[]}
     */
    static getBothTechClassTypes(){
        return [].concat(this.techDecoratorClasses, this.customTechClasses);
    }

    /**
     * Tech boot level 0:
     * Called once, to starting the static api stuff of tech  decorators and custom tech
     */
    static bootingStaticApi(){
        this.getBothTechClassTypes().forEach(function(techClass){
            <TechDecorator>techClass.bootingStaticApi();
        });
    }

    protected techDecoratorInstances:Object = {};

    constructor(protected skyClickPlayer:SkyClickPlayer){

    }

    /**
     * Get tech decorator instance by tech name
     * @param techName
     * @returns {any}
     */
    public getTechDecorator<T>(techName:string):T{
        return this.techDecoratorInstances[techName];
    }

    /**
     * Get array of decorator tech instances
     * @returns {any[]}
     */
    public getAllTechDecorators(){
        return this.instancesToArray(this.techDecoratorInstances);
    }
    /**
     * Convert instance storage object to array
     * @param instances
     * @returns {any[]}
     */
    protected instancesToArray(instances:Object){
        return Object.getOwnPropertyNames(instances).map(function(instanceName){
            return instances[instanceName];
        })
    }

    /**
     * Tech boot level 1:
     * Instantiate for each player instance all tech decorators
     */
    public bootingDecoratorInstance(){
        TechManager.techDecoratorClasses.forEach(((techClass) => {
            this.techDecoratorInstances[techClass.TECH_NAME] = techClass.bootingInstance(this.skyClickPlayer);
        }));
    }

    // Tech boot level 2
    public bootingDecoratorExecution(){
        this.getAllTechDecorators().forEach(((techInstance) => {
            techInstance.bootingExecution();
        }));
    }

}


// WEBPACK FOOTER //
// ./src/app/tech/TechManager.ts